var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmanPlusPlan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17206_20533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.0675 3.09375H11.9325L0 23.9877L11.9325 44.8816H36.0676L48.0001 23.9877L36.0675 3.09375ZM29.5676 33.6306H18.4324L12.8648 23.9877L18.4324 14.3448H29.5676L35.1353 23.9877L29.5676 33.6306ZM29.5855 11.532H18.6001L15.2307 5.90644H32.9798L29.5855 11.532ZM16.0785 12.7962L10.4289 22.5813H4.04235L12.7777 7.28546L16.0785 12.7962ZM10.4289 25.3941L15.9965 35.037L12.7555 40.6508L4.04244 25.394H10.4289V25.3941ZM18.4325 36.4434H29.5676L32.8154 42.0689H15.1847L18.4325 36.4434ZM32.0035 35.0371L37.571 25.3941H43.9576L35.2445 40.651L32.0035 35.0371ZM37.5711 22.5813L32.0127 12.9542L35.3247 7.46482L43.9577 22.5813H37.5711Z",
    fill: "#00747F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5448 14.3438H18.4107L12.8438 23.9857L18.4107 33.6276H29.5448L35.1119 23.9857L29.5448 14.3438Z",
    fill: "#1CADBA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17206_20533"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmanPlusPlan);
export default __webpack_public_path__ + "static/media/aman-plus-plan.e5b84b611e46ca607df60b6d5eb0b8d2.svg";
export { ForwardRef as ReactComponent };